import { SWReactIcons } from "@similarweb/icons";
import { setFontVariant } from "@similarweb/styles";
import type {
    IconWithChildrenCellProps,
} from "app/components/React/Table/cells/IconWithChildrenCell/IconWithChildrenCell";
import IconWithChildrenCell from "app/components/React/Table/cells/IconWithChildrenCell/IconWithChildrenCell"; //TODO move to shared styles
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import type { ColorsTheme } from "app/pages/sales-intelligence/types/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled, { css } from "styled-components";
import { tableCellTheme, transitionStyles } from "../../styles";

export const StyledTitleWrapper = styled(FlexRow)`
    column-gap: 4px;
`;

export const StyledTitle = styled.div`
    ${setFontVariant("primaryItem", tableCellTheme.colors.main)};

    line-height: 20px;
`;

export const StyledText = styled.div`
    ${setFontVariant("dataTable1", tableCellTheme.colors.secondary)};
`;

export const StyleIconCell = styled(IconWithChildrenCell)<IconWithChildrenCellProps>`
    &.snippet-list ${SWReactIcons} {
        display: flex;
        padding: 2px;
        box-sizing: border-box;

        & svg {
            width: 20px;
            height: 20px;

            & path {
                ${transitionStyles("fill")};
            }
        }
    }

    ${StyledTitle},
    ${StyledText} {
        ${transitionStyles("color")};
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* start showing ellipsis when 3rd line is reached */
        white-space: pre-wrap;
    }

    & ${SWReactIcons} svg {
        width: 24px;
        height: 24px;

        & path {
            ${transitionStyles("fill")};
        }
    }

    ${({ disabled }) => {
        if (disabled) {
            return css`
                pointer-events: none;
                user-select: none;

                ${StyledTitle},
                ${StyledText} {
                    color: ${tableCellTheme.colors.disabled};
                }

                ${withSWReactIconFillColor((tableCellTheme.icon as Required<ColorsTheme>).disabled)}
            `;
        }
    }};

    &:hover,
    &:active {
        ${StyledTitle},
        ${StyledText} {
            color: ${tableCellTheme.colors.hover};
        }

        ${withSWReactIconFillColor((tableCellTheme.icon as Required<ColorsTheme>).hover)}
    }
`;
